/**
 * La version affichee, et transmise avec chaque plantage.
 *
 * Elle vivait dans index.tsx, que six modules importaient. Or index.tsx ne
 * declare pas seulement des constantes : il monte l'application. Importer la
 * version depuis lui, c'est donc dependre du point d'entree entier — un cycle
 * qui ne se resout aujourd'hui que par l'ordre de chargement. D'ou ce fichier.
 */

/**
 * La version annoncee aux utilisateurs : la date du build, en AA.MM.JJ.
 *
 * Elle etait une constante editee a la main — « 3.1.00 », datee du 15/04/2026
 * alors que les builds tournaient en aout. Une version qu'on doit penser a
 * monter est une version qu'on oublie de monter, et deux bundles differents
 * finissent par porter la meme chaine.
 *
 * La date resout les deux : on ne peut pas oublier de l'incrementer, et elle
 * est ordonnee — entre deux utilisateurs, on sait immediatement lequel est en
 * retard. C'est tout ce qu'on lui demande depuis que `version_timed` porte le
 * SHA.
 *
 * `REACT_APP_VERSION` est pose par le script de deploiement, qui derive la
 * date de son horodatage de release. En local il n'y a pas de deploiement,
 * donc pas de date : « dev » est alors la reponse honnete.
 */
export const version_annoncee = process.env.REACT_APP_VERSION || "dev";

/**
 * Ce qu'on transmet au diagnostic, et ce qu'on montre sur l'ecran de profil.
 *
 * `REACT_APP_BUILD` est pose par le meme script, et vaut exactement le nom du
 * repertoire de release — `HORODATAGE-SHA-SHAENV`. D'un signalement, on va
 * donc au repertoire sans traduire.
 *
 * Voir le ticket 018.
 */
export const version_timed = process.env.REACT_APP_BUILD
    ? `${version_annoncee} (${process.env.REACT_APP_BUILD})`
    : version_annoncee;
